{
  "header": {
    "title": "Datautforskare",
    "description": "Skapa, hantera och analysera medarbetarenkäter för att få djupare insikter",
    "createButton": "Skapa ny rapport"
  },
  "content": {
    "searchInput": {
      "placeholder": "Sök efter enkäter"
    },
    "tagsDropdown": {
      "triggerLabel": "Taggar",
      "placeholder": "Hitta en tagg",
      "options": {
        "employeeEngagement": "Medarbetarengagemang",
        "workplaceCulture": "Arbetsplatskultur",
        "teamSatisfaction": "Teamnöjdhet",
        "performanceFeedback": "Prestationsfeedback",
        "organizationalImprovement": "Organisatorisk förbättring",
        "usa": "USA",
        "europe": "Europa",
        "asia": "Asien",
        "ukraine": "Ukraina"
      }
    }
  },
  "columns": {
    "reportName": "Rapportnamn",
    "tags": "Taggar",
    "creator": "Skapare",
    "status": "Status"
  },
  "detailsPage": {
    "header": {
      "backButton": "Tillbaka till Datautforskaren",
      "description": "Skapa, hantera och analysera medarbetarenkäter för att få djupare insikter",
      "shareReportButton": "Dela rapport",
      "editReportButton": "Redigera rapport"
    },
    "cardMetrcisSection": {
      "title": "Genomsnittligt antal anställda"
    },
    "leaderMetrcisSection": {
      "title": "Ledarmått",
      "description": "Detta diagram visar hur anställda med olika anställningstid svarade på påståendet.",
      "chart": {
        "title": "Arbetsnöjdhetsresultat"
      }
    }
  },
  "builder": {
    "header": {
      "backButton": "Tillbaka till Datautforskaren",
      "addDescriptionButton": "Lägg till beskrivning",
      "cancelButton": "Avbryt",
      "saveReportButton": "Spara rapport"
    },
    "content": {
      "notSupportedLayout": "1/3-layout stöds inte",
      "inputs": {
        "dateRange": {
          "label": "Datumintervall"
        },
        "department": {
          "label": "Avdelning"
        },
        "leader": {
          "label": "Ledare"
        },
        "gender": {
          "label": "Kön"
        },
        "location": {
          "label": "Plats"
        },
        "tenure": {
          "label": "Anställningstid"
        }
      },
      "charts": {
        "heatmap": {
          "title": "Intensitet per avdelning"
        },
        "distribution": {
          "title": "Svarsfördelning"
        },
        "improvement": {
          "title": "Topp 5 förbättrade frågor inom balans mellan arbete och fritid"
        },
        "decline": {
          "title": "Topp 5 försämrade frågor inom balans mellan arbete och fritid"
        },
        "text": {
          "title": "Ledarmått",
          "description": "Översikt över ledarens prestation och feedback"
        }
      }
    },
    "sidebar": {
      "text": {
        "textHeading": {
          "title": "Rubrik",
          "description": "Totalt antal anställda i undersökningen",
          "data": {
            "title": "Ledarmått",
            "description": "Översikt över ledarens prestation och feedback"
          }
        },
        "textSubtitle": {
          "title": "Underrubrik",
          "description": "Totalt antal anställda i undersökningen",
          "data": {
            "title": "Ledarmått",
            "description": "Översikt över ledarens prestation och feedback"
          }
        },
        "textBodyText": {
          "title": "Brödtext",
          "description": "Totalt antal anställda i undersökningen",
          "data": {
            "title": "Ledarmått",
            "description": "Översikt över ledarens prestation och feedback"
          }
        }
      },
      "numbers": {
        "numbersAvgEmployee": {
          "title": "Genomsnittligt antal anställda",
          "description": "Totalt antal anställda i undersökningen",
          "data": {
            "title": "Genomsnittligt antal anställda",
            "description": "Totalt antal anställda i undersökningen"
          }
        },
        "numbersResponseCount": {
          "title": "Antal svar",
          "description": "Antal inskickade svar",
          "data": {
            "title": "Antal svar",
            "description": "Antal inskickade svar"
          }
        },
        "numbersParticipationRate": {
          "title": "Deltagarfrekvens",
          "description": "Procentandel av anställda som svarat",
          "data": {
            "title": "Deltagarfrekvens",
            "description": "Procentandel av anställda som svarat"
          }
        },
        "numbersAverageScore": {
          "title": "Genomsnittligt betyg",
          "description": "Procentandel av anställda som svarat",
          "data": {
            "title": "Genomsnittligt betyg",
            "description": "Procentandel av anställda som svarat"
          }
        },
        "numbersEnps": {
          "title": "eNPS",
          "description": "Procentandel av anställda som svarat",
          "data": {
            "title": "eNPS",
            "description": "Procentandel av anställda som svarat"
          }
        }
      },
      "graphs": {
        "graphsAvgEmployee": {
          "title": "Genomsnittligt antal anställda",
          "description": "Totalt antal anställda i undersökningen",
          "data": {
            "title": "Genomsnittligt antal anställda",
            "description": "Totalt antal anställda i undersökningen"
          }
        }
      }
    }
  }
}
